<template>

  <beautiful-chat
    v-if="user"
    :participants="participants"
    :titleImageUrl="''"
    :onMessageWasSent="onMessageWasSent"
    :messageList="allMessages"
    :newMessagesCount="newMessagesCount"
    :isOpen="isChatOpen"
    :close="closeChat"
    :open="openChat"
    :showEmoji="false"
    :showFile="false"
    :showEdition="true"
    :showDeletion="true"
    :title="$parent.landingPage.chatTitle"
    :showTypingIndicator="showTypingIndicator"
    :showLauncher="false"
    :showCloseButton="false"
    :colors="colors"
    :disableUserListToggle="true"
    :alwaysScrollToBottom="alwaysScrollToBottom"
    :popoverMessage="popoverMessage"
    :messageStyling="messageStyling"
    @onType="handleOnType"
    @edit="editMessage"
    
  />
  <div v-else class="signup-form">
    <h3 class="chathead">
      Please enter your questions<span class="chathead-small">for the student live panel here</span>
    </h3>
    <form @submit.prevent="registerNewUser()">
      <!-- <image-ref
        class="add-profile"
        v-model="newUser.image"
        :placeholder="''"
      /> -->
        <input
          v-for="(field, i) in fields"
          :key="i"
          type="text"
          class="chatname text-field w-input"
          maxlength="256"
          :required="field.required"
          v-model="newUser[field.slug]"
          :placeholder="field.name + (field.required?' *':'')"
        />
      <!-- <input
        type="text"
        class="chatname text-field w-input"
        placeholder="First Name *"
        v-model="newUser.firstName"
        required
      />
      <input
        type="text"
        class="chatname text-field w-input"
        placeholder="Last Name *"
        v-model="newUser.lastName"
        required
      />
      <input
        type="text"
        class="chatname text-field w-input"
        placeholder="Email *"
        v-model="newUser.email"
      />
      <input
        type="text"
        class="chatname text-field w-input"
        placeholder="Current School"
        v-model="newUser.currentSchool"
      /> -->
      <!-- <input type="file" name="Profile Image" @input="selectedImage"> -->
      <input class="chatbtn w-button" :style="{background:landingPage.themeColor,color:landingPage.negativeColor}" type="submit" :value="submitMessage" />
    </form>
  </div>
  
</template>

<script>
import beautifulChat from "../chat-component/Launcher.vue";
// import ImageRef from "../chat-component/ImageRef";
export default {
  name: "chat",
  props:{landingPage:Object,registrationFields:Array},
  components: { beautifulChat },
  async mounted() {
      
let newUser = {}
    for (let field of this.registrationFields) {
      if (field.type != 100) {
        this.fields.push(field);
        newUser[field.slug] = "";
      }
    }
    this.$set(newUser, "newUser");
    let userID = this.$cookies.get("social-chat");
    try {
      if (userID) {
        let { data: user } = await this.$parent.db
          .collection("registrations")
          .item(userID)
          .get();
        this.user = user;
        //       let { data: messages } = await this.$parent.db
        // .collection("messages")
        // .query("approved", "==", false).query("author.itemRefID","==",userID)
        // .get();
        // this.myUnApprovedMessages = messages
      }
    } catch (err) {
      console.log(err);
    }
    // this.listenToParticipants();
    this.getChatMessages();
    this.$parent.db
      .collection("messages")
      .listen(async ({data}) => {
        let item = JSON.parse(data).item
        if (item.approved){
        // if (this.myUnApprovedMessages.find(m=>m._id==item._id)){
        //     this.myUnApprovedMessages = this.myUnApprovedMessages.filter(m=>m._id!=item._id)
        //   }
           this.messageList.push(item)
        } else {
          // if (item.author[0].itemRefID==this.user._id){
          //   this.myUnApprovedMessages.push(item)
          // }
          if (this.messageList.find(m=>m._id==item._id)){
            this.messageList = this.messageList.filter(m=>m._id!=item._id)
          }
        }
        });
  },
  computed:{
    allMessages(){
      let messages =  [...this.messageList,...this.myUnApprovedMessages].map((m) => {
        let author = ""
        if (m.author.length){
          author = m.author[0].itemRefID
          if (author == this.user._id){
            author = "me"
          }
        }
        return {
          type: m.type?m.type.value:"text",
          author:author,
          data: { text: m.text, emoji: m.text },
        };
      });
      return messages.sort((a,b)=>new Date(a._createdDate) - new Date(b._createdDate))
    }
  },
  data() {
    return {
      fields:[],
      popoverMessage:"",
      submitMessage: "Start Chatting",
      newUser: {
        firstName: "",
        lastName: "",
        email: "",
        currentSchool: "",
      },
      user: "",
      participants: [],
      myUnApprovedMessages:[],
      messageList: [], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessagesCount: 212,
      isChatOpen: true, // to determine whether the chat window should be open or closed
      showTypingIndicator: "", // when set to a value matching the participant._id it shows the typing indicator for the specific user
      messageTypes: {
        text: "bu3043a23akg009ckrf0",
        emoji: "bu30nvq23akg009cmk00",
      },
      colors: {
        header: {
          bg: this.landingPage.themeColor||"#5bcaec",
          text: this.landingPage.negativeColor||"#ffffff",
        },
        launcher: {
          bg: "#4e8cff",
        },
        messageList: {
          bg: "#ffffff",
        },
        sentMessage: {
          bg: "#5bcaec",
          text: "#ffffff",
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222",
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867",
        },
      },
      alwaysScrollToBottom: false,
      messageStyling: true,
    };
  },
  methods: {
    async listenToParticipants() {
      let { data: participants } = await this.$parent.db
        .collection("registrations")
        .get();
      this.participants = participants;
      this.$parent.db.collection("registrations").listen(async () => {
        let { data: participants } = await this.$parent.db
          .collection("registrations")
          .get();
        this.participants = participants.map((p) => {
          return { name: p.firstName + " " + p.lastName };
        });
        if (!this.user) {
          let userID = this.$cookies.get("social-chat");
          if (userID) {
            let { data: user } = await this.$parent.db
              .collection("registrations")
              .item(userID)
              .get();
            this.user = user;
          }
        }
      });
    },
    async getChatMessages() {
      let { data: messages } = await this.$parent.db
        .collection("messages")
        .query("approved", "==", true)
        .get();

        //     let { data: userMessages } = await this.$parent.db
        // .collection("messages")
        // .query("approved", "==", false).query("author.itemRefID","==",this.user._id)
        // .get();
      // for (let i in this.myUnApprovedMessages){
      //   if (messages.find(m=>m._id == this.myUnApprovedMessages[i]._id)){
      //     this.myUnApprovedMessages.splice(i,1)
      //   }
      // }
      // messages = [...messages,...this.myUnApprovedMessages].sort((a,b)=>new Date(a._createdDate) - new Date(b._createdDate))
      this.messageList = messages;
      // this.myUnApprovedMessages = userMessages;
    },
    async registerNewUser() {
      this.submitMessage = "Starting...";
      let { data } = await this.$parent.db
        .collection("registrations")
        .post(this.newUser);
      this.$cookies.set("social-chat", data.id);
      let { data: user } = await this.$parent.db
        .collection("registrations")
        .item(data.id)
        .get();
      this.user = user;
    },
    selectedImage(event) {
      this.newUser.image["selectedImage"] = event.target.files[0];
    },
    sendMessage(text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen
          ? this.newMessagesCount
          : this.newMessagesCount + 1;
        this.onMessageWasSent({
          author: "support",
          type: "text",
          data: { text },
        });
      }
    },
    async onMessageWasSent(message) {
      // this.messageList = [ ...this.messageList, Object.assign({},message) ]
      let msg = {}

      msg.type = { _id: this.messageTypes[message.type] };
      msg.author = [{ itemRefID: this.user._id }];
      msg.text = message.data.text || message.data.emoji;

      await this.$parent.db.collection("messages").post(msg);
      this.popoverMessage = "Your message has been received. Thank you!";
    setTimeout(()=>this.popoverMessage="",4000)
      // msg._id = data.id;
      // msg._createdDate = new Date()
      // message.type = {_id:this.messageTypes.text}
      // this.myUnApprovedMessages.push(msg)
      // console.log(this.myUnApprovedMessages)
      // let msg = {
      //     type: "text",
      //     author: "me",
      //     data: { text: message.text, emoji: message.text },
      //   };
      // this.messageList.push(msg)
      // called when the user sends a message
      // this.messageList = [ ...this.messageList, message ]
    },
    openChat() {
      // called when the user clicks on the fab button to open the chat
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false;
    },
    handleScrollToTop() {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType() {
      // console.log('Emit typing event')
    },
    editMessage(message) {
      const m = this.messageList.find((m) => m._id === message._id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },
  },
};
</script>


<style scoped>

.chathead {
  padding: 20px;
}
.chathead-small {
  display: block;
  font-size: smaller;
  font-weight: 300;
}
.chatname {
  max-width: 300px;
  width: 90%;
  margin: 10px auto;
}
.add-profile {
  width: 120px;
  height: 120px;
  margin: 10px auto;
  border-radius: 100%;
  border: 1px solid #e7e7e7;
  outline: none;
  font-size: 40px;
  line-height: 10px;
  padding: 0;
  font-family: bagel;
  color: #e7e7e7 !important;
}

.add-profile:hover {
  border: 1px solid #3898ec;
}

.add-profile::after {
  content: "Your Profile Image here";
  font-family: Archivo, sans-serif;
  font-size: 14px;
  padding: 4px;
  line-height: 1px;
  color: #bbbbbb;
}

.chatbtn {
  max-width: 300px;
  width: 90%;
  background: #3898ec;
  border-radius: 10px;
  transition: all 200ms ease;
}
.chatbtn {
  filter: brightness(92%);
}

.signup-form {
  color: gray;
  padding: 10px 20px;
  background: #f3f3f3;
}
p {
  margin-bottom: 0px;
}
</style>